import React from "react";
import { Drawer } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Grid,
  Typography,
  Avatar,
  IconButton,
  Button,
} from "@mui/material";
import { IoMdClose } from "react-icons/io";
import { useMutation } from "@apollo/client";
import {
  APPROVE_PAYMENT_REQUEST,
  DECLINE_PAYMENT_REQUEST,
} from "../../../Utils/Mutation";
import { useSnackbarHook } from "../../../hooks/useSnackbarHook";
import Loader from "../../Common/Loader";

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: 540,
    flexShrink: 0,
    p: 4,
  },
  drawerPaper: {
    width: 540,
    p: 4,
  },
  toolbar: theme.mixins.toolbar,
}));
const RequestDetails = ({ open, onClose, data }) => {
  const classes = useStyles();
  const { handleClick } = useSnackbarHook();

  const [approveRequest, {  loading, error }] = useMutation(
    APPROVE_PAYMENT_REQUEST
  );

  const [
    declineRequest,
    { data: declineData, loading: declineLoading, error: declineError },
  ] = useMutation(DECLINE_PAYMENT_REQUEST);

  const handleAcceptRequest = async () => {
    await approveRequest({
      variables: {
        withdrawalRequestId: data?._id,
      },
    })
      .then((res) => {
        handleClick(`Payment Request Approved`, "success");
        onClose()
      })
      .catch((err) => {
        handleClick(`${err?.message}`, "error");
      });
  };
  const handleDeclineRequest = async () => {
    await declineRequest({
      variables: {
        withdrawalRequestId: data?._id,
      },
    })
      .then((res) => {
        handleClick(`Payment Request Declined`, "success");
           onClose()
      })
      .catch((err) => {
        handleClick(`${err?.message}`, "error");
      });
  };

  if (error) {
    handleClick(`${error?.message}`, "error");
  }
  if (declineError) {
    handleClick(`${declineError?.message}`, "error");
  }

  return (
    <Drawer
      className={classes.drawer}
      anchor="right"
      open={open}
      onClose={onClose}
      classes={{ paper: classes.drawerPaper }}
    >
      {loading || (declineLoading && <Loader />)}
      <Box sx={{ px: 4, py: 5 }} className={classes.toolbar}>
        <Box align="right">
          <IconButton onClick={onClose}>
            <IoMdClose style={{ fontSize: "20px", color: "#000" }} />
          </IconButton>
        </Box>
        <Typography
          sx={{
            fontFamily: "Lato",
            color: "#0D0D0D",
            fontSize: "14px",
            fontWeight: 600,
            ml: 5,
            mb: 3,
          }}
        >
          Payment Request
        </Typography>

        <Box sx={{ mt: 5 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ fontWeight: 500 }}>Status</Typography>
            <Typography
              sx={{
                fontWeight: 500,
                color: data?.status === "PAID" ? "#3FB763" : "#FF3347",
                textTransform: "capitalize",
              }}
            >
              {data?.status}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: 4,
            }}
          >
            <Typography sx={{ fontWeight: 500 }}>Full Name</Typography>
            <Typography sx={{ fontWeight: 500, textTransform: "capitalize" }}>
              {data?.user?.firstName} - {data?.user?.lastName}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: 4,
            }}
          >
            <Typography sx={{ fontWeight: 500 }}>Amount</Typography>
            <Typography sx={{ fontWeight: 500, textTransform: "capitalize" }}>
              ${data?.amount.toLocaleString()}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: 4,
            }}
          >
            <Typography sx={{ fontWeight: 500 }}>Bank Name</Typography>
            <Typography sx={{ fontWeight: 500, textTransform: "capitalize" }}>
              {data?.bank?.bankName}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: 4,
            }}
          >
            <Typography sx={{ fontWeight: 500 }}>Account Number</Typography>
            <Typography sx={{ fontWeight: 500, textTransform: "capitalize" }}>
              {data?.bank?.accountNumber}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: 4,
            }}
          >
            <Typography sx={{ fontWeight: 500 }}> Routing No.</Typography>
            <Typography sx={{ fontWeight: 500, textTransform: "capitalize" }}>
              {data?.bank?.routingNumber}
            </Typography>
          </Box>

{
  data?.status !== "PAID" && (
              <Box sx={{ mt: 4 }}>
            <Button
            onClick={handleAcceptRequest}
              variant="contained"
              fullWidth
              sx={{ height: "45px", borderRadius: "10px" }}
            >
              Confirm
            </Button>
            <Button
            onClick={handleDeclineRequest}
              variant="contained"
              fullWidth
              color="error"
              sx={{
                height: "45px",
                borderRadius: "10px",
                mt: 3,
                bgcolor: "primary.error",
              }}
            >
              Decline
            </Button>
          </Box>
  )
}
        </Box>
      </Box>
    </Drawer>
  );
};
export default RequestDetails;
